import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { StylesProvider } from './context/StylesContext';
import Layout from './components/Layout';
import SpellCheckPage from './pages/SpellCheckPage';
import LoginPage from './pages/LoginPage';
import LogsPage from './pages/LogsPage';
import PrivateRoute from './components/PrivateRoute';
import InfoPage from './pages/InfoPage';
import ManagementPage from './pages/ManagementPage';
import WritingStylesPage from './pages/WritingStylesPage';

function App() {
  return (
    <ThemeProvider>
      <StylesProvider>
        <AuthProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<SpellCheckPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute requireAdmin>
                      <ManagementPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/logs"
                  element={
                    <PrivateRoute requireAdmin>
                      <LogsPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/info"
                  element={
                    <PrivateRoute requireAdmin>
                      <InfoPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/styles"
                  element={
                    <PrivateRoute requireAdmin>
                      <WritingStylesPage />
                    </PrivateRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </AuthProvider>
      </StylesProvider>
    </ThemeProvider>
  );
}

export default App;